export default "__VITE_ASSET__CNSHzMPl__"